export {
    AnimationPlugin,
    SkeletonUpdatedEvent,
    AnimationMixer,
    AnimationAction,
    AnimationFinishEvent,
    Skeleton,
    type AnimationClip,
    type KeyframeTrack,
    Blend,
    Loop,
    InterpolationMode,
} from '@qunhe/egs-animation';
